import { Model as ORMModel, attr, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'


export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr(),
      wrestlerId: fk({
        to: 'Wrestler',
        as: 'contractedWrestler',
        relatedName: 'ContractWrestler'
      })
    }
  }
  static reducer(action, Contract, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_CONTRACTS:
        session.Contract.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_CONTRACTS:
        action?.payload?.forEach(newItem => {
          session.Contract.upsert(newItem)
        })
        break
      case Types.ADD_CONTRACT:
        const id = action?.payload?.id || getId()
        Contract.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_CONTRACT:
        item = Contract.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_CONTRACT:
        Contract.withId(action.payload.id).delete()
        break
    }
  }
}
